import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import FadeInSection from '@/components/base/FadeInSection';

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <FadeInSection>
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              探索版主管理知识体系
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              六大核心模块，系统化掌握第一版主的全部核心能力
            </p>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((category, index) => (
            <FadeInSection key={category.slug} delay={index * 80}>
              <Link
                to={`/category/${category.slug}`}
                className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all duration-300 cursor-pointer block"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100/70 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${category.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {category.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {category.articleCount} 篇文章
                </span>
              </Link>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}